import { createTelemetryAPI } from '~/utils/telemetry'

export const oomInsightTelemetry = createTelemetryAPI(({ track }) => ({
  // source value: title, related sqls, profiling
  clickDownloadFiles(payload: { source: string }) {
    return track('OOM Insight: Click Download Files', payload)
  },
  clickRelatedDoc(payload: { doc_link: string }) {
    return track('OOM Insight: Click Related Doc', payload)
  },
  clickExpensiveSQLsDetail() {
    return track('OOM Insight: Click Expensive SQLs Detail')
  },
  clickTopSQLDetail() {
    return track('OOM Insight: Click TopSQL Detail')
  },
  clickSlowQueryDetail() {
    return track('OOM Insight: Click Slow Query Detail')
  },
  clickLokiLogsDetail(payload: { keyword: string }) {
    return track('OOM Insight: Click Loki Logs Detail', payload)
  },
  clickConProfDetail() {
    return track('OOM Insight: Click ConProf Detail')
  },
  clickConfigsDetail() {
    return track('OOM Insight: Click Configs Detail')
  }
}))
